import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex space-x-4 justify-center py-4"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", null, "/", -1)

import { availableLanguages } from "@/language";
import { LanguageDetector } from "@/LanguageDetector";
import { LanguageInfo } from "@/LanguageInfo";
import { computed } from "vue";
interface Props {
  text: string;
  language: LanguageInfo;
}

export default /*#__PURE__*/_defineComponent({
  props: {
    text: null,
    language: null
  },
  emits: ["set-language"],
  setup(__props: any, { emit }) {

const props = __props as {
  text: string;
  language: LanguageInfo;
}

const detectedLanguage = computed(() => {
  if (props.language.code != "auto") return props.language;
  let d = new LanguageDetector();
  return d.detectLanguage(props.text);
});



function detectedLanguageYes(): void {
  emit("set-language", detectedLanguage.value);
}

function detectedLanguageNo(): void {}

const availableLanguagesHashset = new Set<string>(availableLanguages)
/** suggest language change? suggest only for supported languages */
const showLanguageSuggestion = computed(() => {
  //only suggest language if language is not selected
  if (props.language.code != "auto") return false;

  if (detectedLanguage.value == null) return false;
  //support only for hebrew this time
  let code = detectedLanguage.value.code
  return availableLanguagesHashset.has(code) 
});

return (_ctx: any,_cache: any) => {
  return (_unref(showLanguageSuggestion))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("p", null, "is it " + _toDisplayString(_unref(detectedLanguage)?.name) + " language?", 1),
        _createElementVNode("button", {
          class: "text-palette2 underline",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (detectedLanguageYes()))
        }, " yes "),
        _hoisted_2,
        _createElementVNode("button", {
          class: "text-palette2 underline",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (detectedLanguageNo()))
        }, " no ")
      ]))
    : _createCommentVNode("", true)
}
}

})